import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  BetaTesters = 'beta-testers',
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  NewCareers = 'new_careers',
  Billing = 'billing',
  EventDebug = 'debug_event_tracking',
  Requisitions = 'requisitions_flag',
  MarkAsHired = 'mark_as_hired',
  MicrosoftMeetingRooms = 'microsoft_meeting_rooms',
}
